import { atom } from 'recoil'

export const step2State = atom({
  key: 'workflowStep2State',
  default: {
    //  left
    Name: '',
    Notes: '',
    FromName: '',
    FromEmail: '',
    ReplyTo: '',
    FromSms: '',
    Tags: [],

    //  right
    Action: false,
    ActivityType: 0,
    ActivityValue: 0,
    ActivityValueType: 0,

    IdFilter: 0,
    IdsFilter: [],
    RecipientLimit: 0,
    LastSendingPeriod: undefined,
    ClickedLink: '',
    IdMessage: 0,

    IdGroup: 0,

    IdField: 0,
    FieldType: 0,
    FieldValue: '',
    IdFieldFilter: 0
  }
})

export const fieldTypeExistingFilterState = atom({
  key: 'workflowFieldTypeExistingFilterState',
  default: 'use-custom'
})

export const activiyTypeExistingFilterState = atom({
  key: 'workflowActivityTypeExistingFilterState',
  default: 'use-custom'
})
